module.exports = "<div class=\"request-sca-box\">\n  <h4 class=\"blue-lowercase\">{{$ctrl.description}}</h4>\n  <button ng-show=\"!$ctrl.busy\" class=\"button rounded\" ng-click=\"$ctrl.sendScaNotification()\">Conferma</button>\n\n  <div ng-show=\"$ctrl.busy\">\n      <p>{{'sca.notification' | translate}}</p>\n      <div class=\"loader big\"></div>\n      <p class=\"caption\">{{'sca.notification.question' | translate}} <a ng-click=\"$ctrl.sendScaNotification()\">{{'sca.notification.resend' | translate}}</a>.</p>\n\n  </div>\n\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/sca/sca.html
 ** module id = 658
 ** module chunks = 0
 **/